import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';
import { exportFormatOptions } from '../../../data/content/exportFormats';

/*
 * Format picker for the export confirmation dialog.
 *
 * Radios rather than a dropdown: there are only two options, and neither "CSV"
 * nor "RTF" tells a reader what it is for. The one-line description is the point
 * of the control, and a menu item has nowhere to put it.
 */
export const ExportFormatOptions = ({ name, onChange, value }) => (
  <FormGroup aria-labelledby={`${name}-label`} className="mt-3 mb-0" role="radiogroup">
    <Label className="fs-0 font-weight-semi-bold" id={`${name}-label`}>
      Format
    </Label>
    {exportFormatOptions.map(option => (
      <FormGroup check key={option.value} className="mb-2">
        <Label check className="cursor-pointer">
          <Input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
          />
          <span className="font-weight-semi-bold">{option.label}</span>
          <span className="text-600 fs--1 d-block">{option.description}</span>
        </Label>
      </FormGroup>
    ))}
  </FormGroup>
);

ExportFormatOptions.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

export default ExportFormatOptions;
